export default [
  {
    path: '/testing',
    name: 'testing',
    redirect: '/testing/deployment',
  },
  {
    path: '/testing/deployment',
    name: 'deployment-testing',
    component: () => import('@/views/pages/testing/DeploymentTesting.vue'),
    meta: {
      pageTitle: 'Deployment Testing',
      layout: 'full',
      resource: 'Auth',
      requiresAuth: false,
      skipFavorites: true,
      //   breadcrumb: [
      //     {
      //       text: 'Testing',
      //     },
      //     {
      //       text: 'Deployment Detection',
      //       active: true,
      //     },
      //   ],
    },
  },
]
